export default __webpack_public_path__ + "static/media/gallery_08.0a4470d7.jpg";